/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StartMenuController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class StartMenuController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class StartMenuController extends cls.ControllerBase /** @lends classes.StartMenuController.prototype */ {
    static __name = "StartMenuController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      // END WARNING
      this._addBehavior(cls.TextVMBehavior);

      // 4st behaviors
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.BackgroundColorVMBehavior);
    }

    attachUI() {
      const session = this.getAnchorNode().getApplication().getSession();
      session.manageStartMenu(this.getAnchorNode(), this.getWidget());

      // Add in sidebar
      context.StartMenuService.add(this.getWidget());
    }

    /**
     * @inheritDoc
     */
    detachUI() {
      // Remove from sidebar
      context.StartMenuService.remove(this.getWidget());
      super.detachUI();
    }
  }

  cls.StartMenuController = StartMenuController;
  cls.ControllerFactory.register("StartMenu", cls.StartMenuController);
});
